let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lqrxi")).then(() => parcelRequire('gqCTt'));